import React from "react";
import { Link } from "react-router-dom";
import logo from "../Asset/Technogenius-logo.png";
import "../store-footer.css";

export default function FooterSection() {
  const openAtTop = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: "auto" }));
  };
  return (
    <footer className="sf-footer">
      <div className="sf-help">
        <div>
          <h2>Need help finding the right part?</h2>
          <p>Talk to our team about compatibility, delivery, or your order.</p>
        </div>
        <Link to="/contact">Contact our team ↗</Link>
      </div>
      <div className="sf-grid">
        <div className="sf-brand">
          <Link to="/" aria-label="Technogenious home" onClick={() => window.scrollTo({ top: 0, behavior: "auto" })}>
            <img src={logo} alt="Technogenious Solutions" />
          </Link>
          <p>
            Parts, accessories, and technical support for your gaming machine.
          </p>
          <p>
            Shop online, arrange store pickup, or ask us about local and
            international delivery.
          </p>
        </div>
        <nav aria-label="Footer shopping">
          <h2>Explore</h2>
          <Link to="/products" onClick={openAtTop}>Shop products</Link>
          <Link to="/gaming-machines" onClick={openAtTop}>Gaming machines</Link>
          <Link to="/services">Technical services</Link>
          <Link to="/gaming-machine-parts-jamaica">Gaming machine parts in Jamaica</Link>
          <Link to="/gaming-machines-for-sale-jamaica">Gaming machines for sale & lease</Link>
          <Link to="/gaming-machine-repair-kingston">Gaming machine repair in Kingston</Link>
          <Link to="/bill-acceptors-jamaica">Bill acceptors in Jamaica</Link>
          <Link to="/ticket-printers-jamaica">Ticket printers in Jamaica</Link>
          <Link to="/pyramid-service-centre-kingston">Pyramid service centre</Link>
          <Link to="/about">About Technogenious</Link>
          <a href="https://technogeniousstays.com/">Technogenious Stays: apartments in Kingston ↗</a>
          <Link to="/cart" onClick={openAtTop}>Your cart</Link>
        </nav>
        <nav aria-label="Footer customer help">
          <h2>Customer help</h2>
          <Link to="/contact">Pickup & delivery enquiries</Link>
          <Link to="/FAQs">Frequently asked questions</Link>
          <Link to="/warranties">Warranties</Link>
          <Link to="/termscondition">Terms & conditions</Link>
          <Link to="/privacy-policy">Privacy policy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </nav>
        <section className="sf-contact" aria-label="Store contact details">
          <h2>Let’s talk</h2>
          <address>
            Shop 4B, 17 Molynes Road
            <br />
            Kingston 10, Jamaica
            <br />
            Mon–Sat, 9:00 am – 6:00 pm
          </address>
          <a href="mailto:technogeniousja@gmail.com">
            technogeniousja@gmail.com
          </a>
          <a href="tel:+18766484163">+1 (876) 648-4163</a>
          <a href="tel:+18764482032">+1 (876) 448-2032</a>
          <a href="https://wa.me/18764482032" target="_blank" rel="noopener noreferrer">WhatsApp +1 (876) 448-2032 ↗</a>
          <p>
            For product advice, have your gaming machine model and part details
            ready.
          </p>
          <Link to="/contact">View contact information →</Link>
        </section>
      </div>
      <div className="sf-bottom">
        <p>
          © {new Date().getFullYear()} Technogenious Solutions Ltd. All rights
          reserved.
        </p>
        <p>Card payments in USD · USD/JMD bank transfers</p>
      </div>
    </footer>
  );
}
